// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"291":"77d95ec7","430":"77d95ec7","475":"bc679898","939":"7f376552"}[chunkId] + ".chunk.css";
};